import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import VollmachtModal from "./modals/VollmachtModal";
import SignPadModal from './modals/SignPadModal';
import playImg from "../../energo-video-play-button.png";
import YtVideoModal from "../shared/YtVideoModal";
import Api from "../../services/ApiService";

/**
 * SignatureComponent
 * 
 * component that allows customer to sign.
 * 
 * @param {setSignature} props - setter for signature object in InquaryPage, this setter will be passed to SignPadComponent
 * @param {signature} props - getter for signature object in InquaryPage
 * @param {step} props - setter for step object in InquaryPage
 * 
 * @returns next step
 */
const SignatureComponent = ({ setStep, data, setData }) => {

    const API = new Api();
    const [vollmachtModal, setVollmachtModal] = useState(false); // show or hide vollmacht modal
    const [signPadModal, setSignPadModal] = useState(false);
    const [hasReadVollmacht, setHasReadVollmacht] = useState(data.partner.x_file_vollmacht_readed); // was vollmacht modal shown
    const [hasSigned, setHasSigned] = useState(data.partner.x_file_vollmacht !== "" ? true : false); // bool did signed or not
    const [ytModal, setYtModal] = useState(false);
    const [vollmachtText, setVollmachtText] = useState("");
    const [summaryText, setSummaryText] = useState("");
    const [notSignedError, setNotSignedError] = useState(false);


    useEffect(() => {
        var energoCompany = 1;

        if (data.partner.state_id == "1443" || data.partner.state_id == "1442") {

            energoCompany = 3
        }

        API.get_document_vollmacht(data.partner.company_type, energoCompany)
            .then(res => {
                setVollmachtText(res.data.body);
                setSummaryText(res.data.summary);
            })
    }, [])


    // When hasSigned value change  hide sign pad
    useEffect(() => {
        if (hasReadVollmacht && data.partner.x_file_vollmacht === "") setSignPadModal(true);
    }, [hasReadVollmacht])


    /**
     *  Handlers
    */

    // checkbox link to show vollmacht modal
    const vollMachtHandler = (e) => {
        e.preventDefault();
        //setHasReadVollmacht(true)
        setVollmachtModal(true)
    }

    const nextHandler = (e) => {
        e.preventDefault();
        setNotSignedError(false);

        if (hasSigned) {
            setStep(6);
        
        } else {
            setNotSignedError(true);
        }
    }

    if (vollmachtText === "") return <div className="text-center"><Spinner animation="border" className="text-energo" /></div>

    // Views
    return (
        <div>
            <Form onSubmit={nextHandler} validated={hasReadVollmacht}>
                <Row className="mb-5">
                    <h5 className="text-energo">Vollmacht</h5>
                </Row>
                <Row className="mt-3">
                    <Col xs="12">
                        <div dangerouslySetInnerHTML={{__html: summaryText}}></div>
                    </Col>
                    <Col>
                        <Button className="shadow-lg btn-energo" onClick={() => setYtModal(true)} style={{ padding: 3 }}>
                            <div
                                style={{
                                    backgroundImage: `url(${playImg})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    width: "200px",
                                    height: "200px",
                                    color: "orange",
                                    fontWeight: 900,
                                    display: "flex", // Enables flexbox
                                    justifyContent: "center", // Centers horizontally
                                    alignItems: "center", // Centers vertically
                                    textAlign: "center", // Optional, centers text inside the div
                                    textShadow: "2px 2px 1px rgba(0, 0, 0, 1)"
                                }}
                            >
                                Vorstellungsvideo anzeigen
                            </div>
                        </Button>
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col xs={12} style={notSignedError ? {border: "1px solid red"}: null}>
                        {hasReadVollmacht ?
                            <Form.Group>
                                <Form.Check
                                    isValid={hasReadVollmacht ? true : false}
                                    isInvalid={notSignedError}
                                    feedback="Sie müssen die Vollmacht lesen und akzeptieren"
                                    feedbackType="invalid"
                                    readOnly
                                    label={
                                        <a
                                            className="link-energo"
                                            onClick={(e) => vollMachtHandler(e)}
                                            href="/#">{hasReadVollmacht ? "Ich habe die Vollmacht gelesen und verstanden" : "Gesamten Vollmachtstext anzeigen und unterschreiben"}
                                        </a>
                                    }
                                    checked={hasReadVollmacht}
                                />
                            </Form.Group> :
                            <div className="text-center">
                                <a
                                    className="link-energo"
                                    onClick={(e) => vollMachtHandler(e)}
                                    href="/#">{hasReadVollmacht ? "Ich habe die Vollmacht gelesen und verstanden" : "Gesamten Vollmachtstext anzeigen und unterschreiben"}
                                </a>
                            </div>
                        }
                    </Col>
                </Row>
                <Row className="justify-content-center mt-5">
                    <Col xs={12} xl="12">
                        {hasSigned ?
                            <img src={"data:image/png;base64," + data.partner.x_file_vollmacht} alt="signature" className="img-fluid" />
                            : null
                        }
                    </Col>
                    <Col xs="12" hidden={!hasReadVollmacht}>
                        <a href="#" onClick={e => { e.preventDefault(); setSignPadModal(true) }} className="link-energo">Unterschrift erneut eingeben</a>
                    </Col>
                </Row>
                <Row className="mt-5 mb-1">
                    <Col className="text-end">
                        <Button variant="warning" onClick={() => setStep(4)} style={{ marginRight: 5 }}>Zurück</Button>
                        <Button type="submit" className="btn-energo">Weiter</Button>
                    </Col>
                </Row>
            </Form>
            <VollmachtModal hasReadVollmacht={setHasReadVollmacht} setNotSignedError={setNotSignedError} show={vollmachtModal} setShow={setVollmachtModal} data={data} setData={setData} vollmachtText={vollmachtText} />
            <SignPadModal
                hasSigned={setHasSigned}
                signature={setData}
                show={signPadModal}
                setShow={setSignPadModal} />
            <YtVideoModal show={ytModal} setShow={setYtModal} />
        </div>
    )
}

export default SignatureComponent;